export const configs = {
  stripePublishableKey: process.env.STRIPE_PUBLISHABLE_KEY || 'pk_test_51Hqd6PF5bbwpi54HsWvuBr09JwZ3Ch1CMy36gREXjAAuVavEo01cnaZ0T5PjsD3790AzUbS5WQXdgN02S8uYMxwv00Cx2wPiaZ',
  apiUrl: process.env.API_URL,
  tawkSrc: process.env.TAWK_SRC,
  signupUrl: process.env.SIGNUP_URL || 'https://identity.dev.utransport.com.au/Account/join',
  shipperSignUpUrl: process.env.SHIPPER_SIGNUP_URL || 'https://identity.dev.utransport.com.au/Account/Register?role=Shipper',
  carrierSignUpUrl: process.env.CARRIER_SIGNUP_URL || 'https://identity.dev.utransport.com.au/Account/Register?role=Carrier',
  gTagKey: process.env.G_TAG_KEY
}
